import { ImagesPopupDirection } from 'platform-components/src/components/images-menu/__popup/images-menu__popup';
import { OnChangeMenuSlug } from 'platform-components/src/components/images-menu/images-menu';
import { RefObject, useState } from 'react';
import { useSelector } from 'react-redux';
import ym from 'react-yandex-metrika';

import * as lessonSelectors from 'common.components/lesson/selectors';

export type UseShowStickersPopupState = {
    shouldShow: boolean;
    anchorRef?: RefObject<HTMLElement>;
    directions?: ImagesPopupDirection[];
    mainOffset?: number;
    onChange?: OnChangeMenuSlug;
};

export const useShowStickersPopup = (props: {
    assignClessonStudentsSticker?: (args: { studentIds: number[]; slug: string }) => void;
    onClosePopup: () => void;
    studentIdsWithoutResult: number[] | null;
}) => {
    const initialState = {
        shouldShow: false,
    };
    const [state, setState] = useState<UseShowStickersPopupState>(initialState);
    const clessonId = useSelector(lessonSelectors.getCLessonId);

    const closeStickersPopup = () => {
        setState(initialState);
        props.onClosePopup();
    };

    const showStickersPopupForCheckbox = (ref: RefObject<HTMLElement>) => {
        setState({
            anchorRef: ref,
            shouldShow: true,
            directions: ['top-start', 'top', 'top-end', 'bottom-start', 'bottom', 'bottom-end'],
            mainOffset: 10,
            onChange: (slug: string) => {
                if (props.assignClessonStudentsSticker && props.studentIdsWithoutResult) {
                    props.assignClessonStudentsSticker({
                        studentIds: props.studentIdsWithoutResult,
                        slug,
                    });

                    ym('reachGoal', 'teacher_lesson_stats_send_sticker_to_all', {
                        sticker_slug: slug,
                        clesson_id: clessonId,
                    });
                }
                closeStickersPopup();
            },
        });
    };
    const showStickersPopupForCell = (ref: RefObject<HTMLElement>, studentId: number) => {
        setState({
            anchorRef: ref,
            shouldShow: true,
            directions: ['top', 'bottom'],
            mainOffset: 8,
            onChange: (slug: string) => {
                if (props.assignClessonStudentsSticker) {
                    props.assignClessonStudentsSticker({
                        studentIds: [studentId],
                        slug,
                    });

                    ym('reachGoal', 'teacher_lesson_stats_send_sticker', {
                        student_id: studentId,
                        sticker_slug: slug,
                        clesson_id: clessonId,
                    });
                }
                closeStickersPopup();
            },
        });
    };

    return {
        stickersPopupState: state,
        showStickersPopupForCheckbox,
        showStickersPopupForCell,
        closeStickersPopup,
    };
};
